<template>
  <div class="min-h-screen bg-black text-white p-4 sm:p-6 md:p-8">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-8 sm:mb-12">
        <h1 class="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-4 text-capoeira-700">Torneo Regional</h1>
        <p class="text-base sm:text-lg md:text-xl text-gray-600">Sistema de gestión de torneos en tiempo real</p>
      </div>

      <!-- Cards de opciones -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      <!-- Admin -->
      <router-link to="/admin-login" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">👨‍💼</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Panel Admin</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Crea torneos, genera llaves y gestiona categorías</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Ir al Admin →
          </div>
        </div>
      </router-link>

      <!-- Jueces -->
      <router-link to="/jueces" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">⚖️</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Panel de Jueces</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Interfaz para que los jueces registren votos</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Ir a Votos →
          </div>
        </div>
      </router-link>

      <!-- Pantalla Pública -->
      <router-link to="/public" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">📺</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Pantalla Pública</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Visualización en vivo del bracket para proyección</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Ver En Vivo →
          </div>
        </div>
      </router-link>

      <!-- Pantallas Múltiples -->
      <router-link to="/public/pantallas" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">🖥️</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Multi-Pantalla</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Abre cada categoría en pantalla independiente</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Abrir Pantallas →
          </div>
        </div>
      </router-link>

      <!-- Podio -->
      <router-link to="/public/podio" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">🏆</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Podio</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Top 3 de todas las categorías del torneo</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Ver Podio →
          </div>
        </div>
      </router-link>

      <!-- Combates por competidor -->
      <router-link to="/public/combates" class="group">
        <div class="card p-4 sm:p-6 md:p-8 text-center hover:shadow-lg sm:hover:shadow-xl transition-all hover:scale-105">
          <div class="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">🥋</div>
          <h2 class="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">Combates por Competidor</h2>
          <p class="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Tabla por categoría, ordenada desde el podio</p>
          <div class="text-sm sm:text-base text-capoeira-600 font-semibold group-hover:text-capoeira-700">
            Ver Tabla →
          </div>
        </div>
      </router-link>
    </div>

      <!-- Info -->
      <div class="mt-8 sm:mt-12 bg-blue-50 border-l-4 border-blue-500 p-4 sm:p-6 rounded">
        <h3 class="font-bold text-base sm:text-lg mb-2 sm:mb-3">📋 Instrucciones</h3>
        <ol class="text-sm sm:text-base text-gray-700 space-y-1 sm:space-y-2 list-decimal list-inside">
          <li>Ve al <strong>Panel Admin</strong> y crea un nuevo torneo</li>
          <li>Selecciona las categorías y genera las llaves iniciales</li>
          <li>Los jueces acceden al <strong>Panel de Jueces</strong> e inician sesión</li>
          <li>Los jueces registran sus votos en cada round (3 votos cierran automáticamente)</li>
          <li>La <strong>Pantalla Pública</strong> muestra el bracket en vivo (actualiza en tiempo real)</li>
          <li>Usa <strong>Multi-Pantalla</strong> para abrir cada categoría en ventanas independientes</li>
          <li>Cuando una ronda está completa, el admin genera la siguiente ronda</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
